import { Navigate } from "react-router-dom";

const HasPermission = ({ route, children }) => {
    const permissions = JSON.parse(
        localStorage.getItem("permissions") || "[]"
    );

    return permissions.includes(route)
        ? children
        : <Navigate to="/dashboard" replace />;
};

export default HasPermission;